<!--
  This is a temporary component to display the affected system items in a test page.
-->
<template>
  <div>
    <div v-if="items && items.length > 0" class="risk-container">
      <h5>Government:</h5>
      <div v-for="item in items" :key="item.name">
        <span v-if="item.name.includes('government')" class="risk-container__item">{{
          item.displayName
            .replace(' (HIGH)', '')
            .replace(' (MEDIUM)', '')
            .replace(' (LOW)', '')
            .replace(' (N/A)', '')
        }}</span>
        <span v-if="item.name.includes('government')" class="risk-rating">{{
          item.fields.rating.value
        }}</span>
      </div>
    </div>

    <div v-if="items && items.length > 0" class="risk-container">
      <h5>Businesses:</h5>
      <div v-for="item in items" :key="item.name">
        <span v-if="item.name.includes('business')" class="risk-container__item">{{
          item.displayName
            .replace(' (HIGH)', '')
            .replace(' (MEDIUM)', '')
            .replace(' (LOW)', '')
            .replace(' (N/A)', '')
        }}</span>
        <span v-if="item.name.includes('business')" class="risk-rating">{{
          item.fields.rating.value
        }}</span>
      </div>
    </div>

    <div v-if="items && items.length > 0">
      <h5 class="d-inline-block">Home Users:</h5>
      <div v-for="item in items" :key="item.name" class="d-inline-block">
        <span v-if="item.name.includes('home')" class="risk-rating">{{
          item.fields.rating.value
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Resource-Advisory-RiskCategory',
  props: {
    items: {
      type: Array
    }
  }
};
</script>
<style lang="scss">
.risk-container {
  margin-bottom: 1rem;

  &__item {
    margin: 0 0 0 4.5rem;
    position: relative;

    &:before {
      content: '';
      position: absolute;
      top: 1.5rem;
      transform: translateY(-50%);
      left: -2.5rem;
      display: inline-block;
      width: 0.8rem;
      height: 0.8rem;
      border-radius: 4rem;
      background-color: $orange;
    }

    &:after {
      content: ':';
    }
  }
}

.risk-rating {
  font-weight: 500;
  margin-left: 0.5rem;
}
</style>
